/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copy'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Name',
    PROFIT_MARGIN: 'Commission percentage'
  },
  LABEL: {
    GENERATE_LINK: 'Generate link',
    GENERATED_LINK: 'Generated Link',
    NAME: 'Name',
    PROFIT_MARGIN: 'Commission percentage'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Link copied'
  },
  TOOLTIP: {
    NAME: 'Name',
    PROFIT_MARGIN: 'Commission percentage'
  }
};
